module.exports = __webpack_public_path__ + "img/thumbnail_PlainsZebra_j_albino.3d642a21.png";